import { createContext, useContext, useEffect, useState } from "react";
import CryptoJS from "crypto-js";

export const ModeContext = createContext({
  themeMode: "light",
  DarkMode: () => {},
  LightMode: () => {},
  userSession: { userId: "", UserType: "", CreatedBy: "" },
  refreshUserSession: () => {},

  refreshRoleAccess: () => {},

  getAccessFor: () => ({
    canAdd: false,
    canEdit: false,
    canRead: false,
    canDelete: false,
  }),
});

export const ModeContextProvider = ({ children }) => {
  const [themeMode, setThemeMode] = useState("light");
  const LightMode = () => setThemeMode("light");
  const DarkMode = () => setThemeMode("dark");

  const [roleAccess, setRoleAccess] = useState([]);

  const SECRET_KEY =
    process.env.REACT_APP_SECRET_KEY || "YourStrongSecretKey123!";

  const SECRET_KEYU =
    process.env.REACT_APP_SECRET_KEY || "KT@12345_MY_SECRET_KEY";

  const loadRoleAccess = () => {
    try {
      const encrypted = sessionStorage.getItem("RoleDetails");
      if (!encrypted) return [];

      const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      const parsed = JSON.parse(decryptedData);
      console.log("Role Menu's", parsed);

      return parsed.oLines || [];
    } catch (err) {
      console.error("Error decrypting RoleDetails:", err);
      return [];
    }
  };

  const [userSession, setUserSession] = useState({
    userId: "",
    UserType: "",
    CreatedBy: "",
  });

  useEffect(() => {
    // always read fresh data inside useEffect
    const userData = sessionStorage.getItem("userData");

    if (userData) {
      try {
        const parsed = JSON.parse(userData);

        setUserSession({
          userId: parsed.Username || "",
          UserType: parsed.UserType || "",
          CreatedBy: parsed.Username || "",
        });
        const oLinesData = loadRoleAccess();
        setRoleAccess(oLinesData);
      } catch (error) {
        console.error("Error parsing userData:", error);
      }
    }
  }, []);

  const getStoredUser = () => {
    try {
      return JSON.parse(sessionStorage.getItem("userData")) || {};
    } catch {
      return {};
    }
  };

  const refreshUserSession = () => {
    const data = getStoredUser();

    setUserSession({
      userId: data.Username || "",
      UserType: data.UserType || "",
      CreatedBy: data.Username || "",
    });
  };

  const refreshRoleAccess = () => {
    const updatedData = loadRoleAccess();
    setRoleAccess(updatedData);
  };

  // const checkAccess = (MenuId, permissionType) => {
  //   try {
  //     const found = roleAccess?.find((r) => r.MenuId === MenuId);
  //     if (!found) return false;

  //     // permissionType can be one of: "IsAdd", "IsEdit", "IsDelete", "IsRead"
  //     return found[permissionType] === true;
  //   } catch (err) {
  //     console.error("Error checking access:", err);
  //     return false;
  //   }
  // };

  function checkAccess(menuId, permission = "IsRead") {
    if (!roleAccess || !menuId) return false;
    const menuIdStr = String(menuId);

    if (menuIdStr.includes("-")) {
      const [parentMId, specialMId] = menuIdStr.split("-");

      const parentItem = roleAccess.find((r) => String(r.MenuId) === parentMId);
      if (!parentItem) return false;

       if (permission === "IsRead") {
        return (
          Array.isArray(parentItem.oSpecialAccess) &&
          parentItem.oSpecialAccess.some((s) => String(s.MenuId) === specialMId)
        );
      }

       const childExists =
        Array.isArray(parentItem.oSpecialAccess) &&
        parentItem.oSpecialAccess.some((s) => String(s.MenuId) === specialMId);

      return childExists && parentItem[permission] === true;
    }

    // Simple flat MenuId
    const item = roleAccess.find((r) => String(r.MenuId) === menuIdStr);
    if (!item) return false;
    return item[permission] === true;
  }

  return (
    <ModeContext.Provider
      value={{
        themeMode,
        LightMode,
        DarkMode,
        userSession,
        refreshUserSession,
        roleAccess,
        refreshRoleAccess,
        // checkAccess,
        checkAccess: (menuId, permission) => checkAccess(menuId, permission),
      }}
    >
      {children}
    </ModeContext.Provider>
  );
};

export const useThemeMode = () => useContext(ModeContext);
